<template>
  <div>
    <div class="text-h6">Design Group</div>
    <v-btn
      text
      class="pl-0 mt-4"
      @click="back"
    >
      &lt; Back
    </v-btn>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <EditDesignGroup />
      </v-col>
      <v-col
        cols="12"
        md="9"
      >
        <DesignGroupCategories
          class="mb-4"
          @reload="loadData"
        />
        <Templates
          v-if="!loading"
          show-title
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import EditDesignGroup from '@/components/designgroups/Edit';
import DesignGroupCategories from '@/components/designgroups/category/List';
import Templates from '@/components/catalog/Templates';

export default {
  name: 'DesignGroupDetail',

  components: {
    EditDesignGroup,
    DesignGroupCategories,
    Templates
  },

  data() {
    return { loading: true };
  },

  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      Promise.all([
        this.$store.dispatch('designgroups/get', this.id),
        this.$store.dispatch('lookup/getCategories'),
        this.$store.dispatch('lookup/getDesignGroups'),
        this.$store.dispatch('lookup/getCatalogContentPages'),
        this.$store.dispatch('catalog/filter', {
          designGroupId: this.id,
          page: 1
        })
      ])
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
